/**
 * Pure helpers for the Landing page certifications grid.
 *
 * Extracted so the "Show more" toggle behavior is unit-testable without
 * pulling in jsdom / framer-motion. The bug we are guarding against:
 * previously, expanded cards mounted INSIDE a stale Framer Motion stagger
 * container and stayed invisible, so `visibleCerts` returned the right
 * number of items but the user still saw nothing new on screen.
 *
 * The animation fix lives in `src/pages/Landing.tsx` (expanded items use
 * their own `initial`/`animate` instead of inheriting variants). These
 * helpers guarantee that, at minimum, the slicing math is correct.
 *
 * Initial visible count is 6 so the collapsed view fills two balanced rows
 * on every breakpoint: 6×1 on mobile, 3×2 on tablet (`md:grid-cols-2`), and
 * 2×3 on desktop (`lg:grid-cols-3`). When 6 or fewer certs exist, every card
 * is shown and the "Show more" toggle is hidden.
 */
export const INITIAL_CERTS_VISIBLE = 6;

export function getVisibleCerts<T>(certs: T[], showAll: boolean): T[] {
  return showAll ? certs : certs.slice(0, INITIAL_CERTS_VISIBLE);
}

export function hasMoreCerts<T>(certs: T[]): boolean {
  return certs.length > INITIAL_CERTS_VISIBLE;
}

export function hiddenCertCount<T>(certs: T[]): number {
  return Math.max(0, certs.length - INITIAL_CERTS_VISIBLE);
}